import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import Loader from 'components/Loader';
import './ConfirmationDialog.scss';

function ConfirmationDialog(props) {
  const { heading, content } = props;
  const { children } = props;
  const {
    onConfirmation,
    onCancel,
    isLoading,
    isConfirmDisabled,
    primaryLabel,
    showCancel,
  } = props;

  const handleConfirmation = () => {
    onConfirmation();
    document.body.classList.remove('p-overflow-hidden');
  };

  const handleCancel = () => {
    onCancel();
    document.body.classList.remove('p-overflow-hidden');
  };

  return (
    <Dialog
      modal
      visible
      onHide={handleCancel}
      draggable={false}
      className="confirmation-dialog"
      blockScroll
    >
      {isLoading ? (
        <div className="col-12 loader-container" data-testid="loader">
          <Loader />
        </div>
      ) : (
        <div className="row g-0 mx-4 my-4">
          {heading && (
            <div className="col-12">
              <h2 className="mb-3">{heading}</h2>
            </div>
          )}
          <div className="col-12">
            {typeof content === 'string' ? (
              <p className="mb-2">{content}</p>
            ) : (
              content
            )}
          </div>
          <div className="col-12"> {children}</div>
          <div className="col-12">
            <Button
              type="submit"
              onClick={handleConfirmation}
              label={primaryLabel}
              className="col-6 action-button"
              data-testid="confirm-btn"
              disabled={isConfirmDisabled}
            />
            {showCancel && (
              <Button
                className="p-button-secondary col-6 action-button"
                onClick={handleCancel}
                label="Cancel"
                data-testid="cancel-btn"
              />
            )}
          </div>
        </div>
      )}
    </Dialog>
  );
}
ConfirmationDialog.propTypes = {
  heading: PropTypes.string,
  content: PropTypes.node.isRequired,
  onConfirmation: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.element,
  isConfirmDisabled: PropTypes.bool,
  primaryLabel: PropTypes.string,
  showCancel: PropTypes.bool,
};

ConfirmationDialog.defaultProps = {
  heading: '',
  children: null,
  isConfirmDisabled: false,
  primaryLabel: 'Confirm',
  showCancel: true,
};

export default ConfirmationDialog;
